import axios from 'axios'
import Vapi from 'vuex-rest-api'

const api = new Vapi({
  axios,
  state: {},
})
  .post({
    action: 'sendSupport',
    property: 'supportResult',
    path: '/support',
  })
  .getStore({ namespaced: true })

export default api
